import AthenaTextarea from 'athena/components/textarea';
import { css } from '@emotion/react';
import { QuestionProps } from './types';

const styles = css`
  &.text-question {
    .athena-input {
      min-height: 140px !important;
    }
  }
`;

const TextQuestion = ({
  questionId,
  questionIndex,
  questionText,
  onResponse,
  dataQA,
  dataQAId,
}: QuestionProps) => (
  <AthenaTextarea
    css={styles}
    className='text-question'
    showLabel={false}
    placeholder={questionText}
    onChange={({ target: { value } }) => onResponse(questionIndex, questionId, value)}
    data-qa={dataQA}
    data-qa-id={dataQAId}
  />
);

export default TextQuestion;
